import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrollt bei jedem Routen-Wechsel an den Seitenanfang.
 * React Router behält sonst die Scroll-Position der vorherigen Seite bei.
 * Bei reinen Query-/Hash-Änderungen (gleicher Pfad) wird NICHT gescrollt,
 * damit z.B. Filter-URLs die Position behalten.
 */
const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
